(function () {
  'use strict';

  if (window.KHAIR_PRODUCT_TRACKING && window.KHAIR_PRODUCT_TRACKING.version) return;

  var VERSION = '2026-08-20.1';
  var CAMPAIGN_KEY = 'khair_campaign_context_v1';
  var originalFetch = window.fetch;
  var context = window.KHAIR_TRACKING_CONTEXT || {};
  var productViewSent = false;

  function analyticsAllowed() {
    try {
      return Boolean(
        window.Shopify &&
          window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
          window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function clean(value, fallback) {
    var result = value === undefined || value === null ? '' : String(value).trim();
    return (result || fallback || '').slice(0, 255);
  }

  function campaignFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var campaign = {
      source: clean(params.get('utm_source')),
      medium: clean(params.get('utm_medium')),
      campaign: clean(params.get('utm_campaign')),
      content: clean(params.get('utm_content')),
      campaignId: clean(params.get('utm_id')),
      adId: clean(params.get('ad_id')),
    };

    if (!campaign.source && document.referrer) {
      try {
        var referrer = new URL(document.referrer);
        if (referrer.origin !== window.location.origin) campaign.source = clean(referrer.hostname);
      } catch (error) {
        campaign.source = '';
      }
    }
    return campaign;
  }

  function hasCampaignValue(campaign) {
    return Object.keys(campaign).some(function (key) {
      return Boolean(campaign[key]);
    });
  }

  function saveCampaignContext() {
    if (!analyticsAllowed()) return campaignFromUrl();
    var current = campaignFromUrl();
    try {
      if (hasCampaignValue(current)) {
        sessionStorage.setItem(CAMPAIGN_KEY, JSON.stringify(current));
        return current;
      }
      var stored = JSON.parse(sessionStorage.getItem(CAMPAIGN_KEY) || '{}');
      return stored && typeof stored === 'object' ? stored : current;
    } catch (error) {
      return current;
    }
  }

  function clarityCall(callback, attempt) {
    if (!analyticsAllowed()) return;
    if (typeof window.clarity === 'function') {
      try {
        callback(window.clarity);
      } catch (error) {
        return;
      }
      return;
    }
    if ((attempt || 0) < 20) {
      window.setTimeout(function () {
        clarityCall(callback, (attempt || 0) + 1);
      }, 500);
    }
  }

  function sendClarityEvent(name, tags) {
    if (!analyticsAllowed()) return;
    var campaign = saveCampaignContext();
    var combined = Object.assign(
      {
        khair_traffic_source: clean(campaign.source, 'direct'),
        khair_traffic_medium: clean(campaign.medium, 'none'),
        khair_campaign: clean(campaign.campaign, 'none'),
        khair_campaign_content: clean(campaign.content, 'none'),
        khair_campaign_id: clean(campaign.campaignId, 'none'),
        khair_ad_id: clean(campaign.adId, 'none'),
      },
      tags || {}
    );

    clarityCall(function (clarity) {
      Object.keys(combined).forEach(function (key) {
        clarity('set', key, clean(combined[key], 'unknown'));
      });
      clarity('event', name);
    });
  }

  function productTags(item, surface) {
    var product = context.product || {};
    var price = item && (item.final_price || item.price);
    var quantity = item && item.quantity ? Number(item.quantity) : 1;
    var lineValue = Number(price || product.price || 0) * quantity;
    return {
      khair_product_handle: clean(item && item.handle, clean(product.handle, 'unknown')),
      khair_product_title: clean(item && item.product_title, clean(product.title, 'unknown')),
      khair_variant_title: clean(item && item.variant_title, 'default'),
      khair_variant_id: clean(item && item.id, 'unknown'),
      khair_sku: clean(item && item.sku, 'none'),
      khair_quantity: clean(quantity, '1'),
      khair_value_gbp: lineValue ? (lineValue / 100).toFixed(2) : 'unknown',
      khair_atc_surface: clean(surface, 'unknown'),
    };
  }

  function currentSurface() {
    var trigger = document.activeElement;
    if (!trigger || !trigger.closest) return 'unknown';
    if (trigger.closest('[id*="sticky"], [class*="sticky"]')) return 'sticky_product_button';
    if (trigger.closest('quick-add-modal, .quick-add')) return 'quick_add';
    if (trigger.closest('product-form, form[action*="/cart/add"]')) return 'product_button';
    return 'unknown';
  }

  function addedItems(payload) {
    if (!payload || typeof payload !== 'object') return [];
    if (Array.isArray(payload.items)) return payload.items;
    return payload.id ? [payload] : [];
  }

  function isCartAddRequest(input) {
    var raw = typeof input === 'string' ? input : input && input.url;
    if (!raw) return false;
    try {
      var pathname = new URL(raw, window.location.origin).pathname.replace(/\/$/, '');
      return pathname.endsWith('/cart/add') || pathname.endsWith('/cart/add.js');
    } catch (error) {
      return false;
    }
  }

  function trackSuccessfulAdd(payload, surface) {
    addedItems(payload).forEach(function (item) {
      var tags = productTags(item, surface);
      sendClarityEvent('khair_add_to_cart_success', tags);
      document.dispatchEvent(
        new CustomEvent('khair:add_to_cart_success', {
          detail: {
            productHandle: tags.khair_product_handle,
            productTitle: tags.khair_product_title,
            variantTitle: tags.khair_variant_title,
            variantId: tags.khair_variant_id,
            valueGbp: tags.khair_value_gbp,
            surface: tags.khair_atc_surface,
          },
        })
      );
    });
  }

  function installFetchTracking() {
    if (typeof originalFetch !== 'function') return;
    window.fetch = function () {
      var args = arguments;
      var isCartAdd = isCartAddRequest(args[0]);
      var surface = isCartAdd ? currentSurface() : '';
      var responsePromise = originalFetch.apply(this, args);
      if (!isCartAdd) return responsePromise;

      return responsePromise.then(function (response) {
        if (response && response.ok) {
          response
            .clone()
            .json()
            .then(function (payload) {
              if (!payload.status) trackSuccessfulAdd(payload, surface);
            })
            .catch(function () {});
        }
        return response;
      });
    };
  }

  function installProductInteractionTracking() {
    if (!context.product) return;
    trackProductView();

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('input[name="id"], select[name="id"]')) return;
      var variantTitle = input.dataset && (input.dataset.title || input.dataset.optionValueName);
      sendClarityEvent('khair_size_selected', {
        khair_product_handle: clean(context.product.handle, 'unknown'),
        khair_product_title: clean(context.product.title, 'unknown'),
        khair_variant_title: clean(variantTitle || input.value, 'unknown'),
        khair_variant_id: clean(input.value, 'unknown'),
      });
    });
  }

  function trackProductView() {
    if (!context.product || productViewSent || !analyticsAllowed()) return;
    productViewSent = true;
    sendClarityEvent('khair_product_view', productTags(null, 'product_page'));
  }

  function onConsentCollected() {
    saveCampaignContext();
    trackProductView();
  }

  function initialize() {
    saveCampaignContext();
    installFetchTracking();
    installProductInteractionTracking();
    document.documentElement.setAttribute('data-khair-product-tracking', VERSION);
  }

  window.KHAIR_PRODUCT_TRACKING = {
    version: VERSION,
    analyticsAllowed: analyticsAllowed,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('visitorConsentCollected', onConsentCollected);
  document.addEventListener('shopify:consent-collected', onConsentCollected);
})();
